import { render } from "./NotesPage.vue?vue&type=template&id=2d87c073&scoped=true"
import script from "./NotesPage.vue?vue&type=script&lang=js"
export * from "./NotesPage.vue?vue&type=script&lang=js"

import "./NotesPage.vue?vue&type=style&index=0&id=2d87c073&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d87c073"]])

export default __exports__